<template>
  <div>
    <div v-show="ui.step === 0">
      <img src="img/consent/pers-1.png">
      <p class="text-xs-center">Vous avez été pré-inscrit(e) au programme CoviDIAB Algérie.</p>
      <p class="text-xs-center primary--text fw500">Vous devez maintenant compléter votre inscription pour activer votre suivi.</p>
      <p class="text-xs-center">Cela se fait en 3 étapes et prend 2 minutes seulement.</p>
      <v-btn block
             rounded
             class="primary mt-4"
             @click="ui.step++">Commencer
      </v-btn>
    </div>

    <div v-show="ui.step === 1">
      <h3 class="mt-2 primary--text text-xs-center fw500">Etape 1/5</h3>
      <v-progress-linear class="mb-4"
                         :value="20"></v-progress-linear>

      <p>Vérifiez que les <span class="primary--text fw500">moyens de contact</span> indiqués ci-dessous sont corrects, corrigez si besoin :</p>
      <p>Ils seront utilisés pour vous prévenir lors d'une <span class="primary--text fw500">nouvelle étape de votre suivi</span>, ou d'un <span class="primary--text fw500">message de votre soignant.</span></p>
      <v-text-field placeholder="Adresse e-mail"
                    outlined
                    label="Adresse e-mail"
                    type="email"
                    v-model="user.email"></v-text-field>

      <v-text-field placeholder="Numéro de téléphone"
                    outlined
                    label="N° de téléphone"
                    mask="## ## ## ## ##"
                    type="tel"
                    v-model="user.phoneNumber"></v-text-field>

      <v-btn block
             rounded
             class="primary"
             @click="ui.step++">Confirmer
      </v-btn>
    </div>

    <div v-show="ui.step === 2">
      <h3 class="mt-2 primary--text text-xs-center fw500">Etape 2/5</h3>
      <v-progress-linear class="mb-4"
                         :value="40"></v-progress-linear>

      <p class="mt-4">Votre identifiant de connexion : </p>
      <p class="text-center primary--text fw500">{{ user.username }}</p>

      <p>Choisissez le mot de passe qui servira à protéger votre compte CoviDIAB Algérie.</p>
      <v-text-field placeholder="Mot de passe"
                    outlined
                    label="Choisir un mot de passe"
                    required
                    type="password"
                    autocorrect="off"
                    autocapitalize="off"
                    spellcheck="false"
                    v-model="user.password"></v-text-field>

      <v-text-field placeholder="Mot de passe"
                    outlined
                    label="Confirmer le mot de passe"
                    required
                    type="password"
                    autocorrect="off"
                    autocapitalize="off"
                    spellcheck="false"
                    v-model="user.password_confirm"></v-text-field>

      <MangoCaption>NB : notez votre nom d'utilisateur et mot de passe, ils vous seront demandés lors de vos connexions ultérieures à CoviDIAB Algérie.</MangoCaption>

      <v-btn block
             rounded
             class="primary"
             @click="ui.step++"
             :disabled="!user.password || user.password !== user.password_confirm">Continuer
      </v-btn>
    </div>

    <div v-show="ui.step === 3">
      <h3 class="mt-2 primary--text text-xs-center fw500">Etape 3/5</h3>
      <v-progress-linear class="mb-4"
                         :value="60"></v-progress-linear>

      <p>Nous avons besoin de quelques informations supplémentaires :</p>

      <IriadeRadioGroup v-model="user.gender"
                        label="Sexe"
                        :options="[{label: 'Homme', value: 'homme'}, {label: 'Femme', value: 'femme'}, {label: 'Autre', value: 'autre'}]"></IriadeRadioGroup>

      <IriadeMaskedTextInput mask="##/##/####"
                             mask-label="jj/mm/aaaa"
                             label="Date de naissance"
                             v-model="user.birthdate"/>

      <IriadeTextInput label="Ville"
                       v-model="user.city"></IriadeTextInput>

      <v-btn block
             rounded
             class="primary"
             @click="ui.step++"
             :disabled="!user.gender || !user.birthdate || user.birthdate.length < 10 || !user.city">Continuer
      </v-btn>
    </div>

    <div v-show="ui.step === 4">
      <h3 class="mt-2 primary--text text-xs-center fw500">Etape 4/5</h3>
      <v-progress-linear class="mb-4"
                         :value="80"></v-progress-linear>
      <p>Renseignez, <span class="primary--text fw500">si vous le savez,</span> le contenu des champs suivants :</p>
      <IriadeTextInput label="Votre médecin traitant"
                       v-model="user.medecin_traitant"></IriadeTextInput>
      <IriadeTextInput label="Votre diabétologue"
                       v-model="user.diabetologue"></IriadeTextInput>
      <IriadeTextInput label="Votre centre hospitalier"
                       v-model="user.centre_hospitalier"></IriadeTextInput>
      <v-btn block
             rounded
             class="primary"
             @click="ui.step++">Continuer
      </v-btn>
    </div>

    <div v-show="ui.step === 5">
      <h3 class="mt-2 primary--text text-xs-center fw500">Etape 5/5</h3>
      <v-progress-linear class="mb-4"
                         :value="100"></v-progress-linear>

      <p class="text-xs-center">Votre participation à CoviDIAB Algérie nécessite d'enregistrer votre consentement.</p>

      <b class="text-xs-center mb-2">Lisez attentivement les conditions d'utilisation du service CoviDIAB Algérie ci-dessous :</b>

      <div class="px-2 py-1 mb-4"
           style="height: 200px; overflow-y: scroll; border: 1px solid #EFEFEF">
        <p>
          Le programme d’accompagnement médical CoviDIAB Algérie s’adresse à des patients diabétiques, exposés au risque COVID-19 (coronavirus – SARS-CoV2). CoviDIAB Algérie est un service édité par Iriade, société française, SAS au capital de 5000 euros SIRET 823 925 391 – contact@iriade.fr - iriade.fr.
        </p>

        <p class="pt-1">
          L’inscription au programme d’accompagnement CoviDIAB Algérie peut être réalisée directement par le patient à son initiative personnelle ou par un soignant (médecin ou autre professionnel de santé). Le programme CoviDIAB Algérie consiste à recevoir régulièrement des messages email et SMS sollicitant de répondre à des questionnaires, saisir des données biométriques et biologiques, et proposant des éléments d’information comme des vidéos, articles, etc. Votre inscription et la participation au programme CoviDIAB Algérie nécessite de pouvoir vous contacter par email et SMS (aucune information personnelle n’est indiquée dans les emails et SMS). Il est aussi nécessaire de disposer d’un ordinateur, une tablette ou un smartphone reliés à Internet pour bénéficier du programme CoviDIAB Algérie, et l’offre CoviDIAB Algérie n’inclut pas la mise à disposition de ces dispositifs de communication. CoviDIAB Algérie est mis gracieusement à disposition des patients, il ne peut leur être demandé de redevance sous quelque forme que ce soit pour y accéder. Vous ne percevrez aucune indemnisation pour votre participation à CoviDIAB Algérie. Par ailleurs, CoviDIAB Algérie n’entraînera pour vous aucuns frais supplémentaires, hors les frais éventuels de connexion à Internet et de réception des messages SMS. Les promoteurs du programme CoviDIAB Algérie et la société IRIADE ne peuvent être tenu responsables pour les défauts de fonctionnement qui pourraient apparaitre lors de l’utilisation du service web, email ou SMS, ni des difficultés à se connecter à Internet ou faire fonctionner le matériel informatique et de télécommunication.
        </p>

        <p class="pt-1">
          Le contenu et les objectifs du programme CoviDIAB Algérie vous sont expliqués sur le site covidiab-algerie.com, et peuvent aussi vous être expliqués par les professionnels de santé qui vous recommandent d’y participer. La participation au programme d’accompagnement CoviDIAB Algérie n’implique en aucun cas l’adoption d’une attitude thérapeutique ou la prise d’un traitement spécifique ou adapté. La prise en charge, le parcours de soins et le traitement que vous ont éventuellement proposés votre médecin ou votre centre de soins, en conformité avec les recommandations actuelles pour le traitement de l’infection au coronavirus, ne sera pas modifié du fait de votre participation au programme d’accompagnement CoviDIAB Algérie. Si le traitement ou les objectifs thérapeutiques vous concernant sont modifiés au cours de votre participation au télésuivi CoviDIAB Algérie, il s’agit toujours d’une décision indépendante et responsable effectuée uniquement par votre médecin. Les changements qui peuvent apparaitre dans le programme CoviDIAB Algérie au cours du temps ne reflètent que les décisions prises par votre médecin, elles ne sont en aucun cas automatisées ou suggérées par le programme CoviDIAB Algérie. La participation au programme d’accompagnement CoviDIAB Algérie n’implique en aucun cas la réalisation d’examens complémentaires spécifiques. Les résultats d’examens complémentaires qui peuvent être enregistrés dans le programme CoviDIAB Algérie ne sont pas utilisés pour modifier ou suggérer une adaptation automatique de votre traitement par le système CoviDIAB Algérie.
        </p>

        <p class="pt-1">
          Votre participation à CoviDIAB Algérie est volontaire et doit rester libre de toute contrainte. Elle nécessite votre validation (case à cocher) pour exprimer votre consentement. Même après avoir validé ce consentement, vous pourrez arrêter de participer au programme d’accompagnement CoviDIAB Algérie à tout moment, simplement, soit en utilisant le lien de désinscription figurant dans l’application et en suivant les instructions qui s’affichent, ou en informant l’administrateur responsable des données personnelles à l’adresse : cdo@iriade.fr, ou en envoyant un courrier à Iriade - 8 avenue des tilleuls 31280 Mons - France. Lors du suivi CoviDIAB Algérie, nous sommes amenés à collecter les données que vous nous confiez de façon à pouvoir les cumuler avec celles d’autres patients qui bénéficient du même suivi et les traiter statistiquement à des fins de recherche. Si vous retirez votre consentement, afin de garantir la validité de la recherche, les données codées jusqu’au moment de votre interruption seront conservées, sauf demande explicite de suppression. Conformément à l'article 34 de la Loi Française Informatique et Liberté du 6 janvier 1978, et la Loi Algérienne n° 18-07 du 10 juin 2018 relative à la protection des personnes physiques dans le traitement des données à caractère personnel, vous disposez d'un droit d'accès, de modification, de rectification et de suppression des données vous concernant. Les données recueillies lors du suivi sont confidentielles et votre anonymat est garanti, y compris en cas d’analyses statistiques sur l’ensemble des suivis CoviDIAB Algérie et lors de la publication des résultats.
        </p>

        <p class="pt-1">
          Vous pouvez toujours contacter un membre de l’équipe CoviDIAB Algérie si vous avez besoin d’informations complémentaires en envoyant un message à contact@covidiab-algerie.com Si vous avez besoin d’informations complémentaires, mais aussi en cas de problème ou d’inquiétude, vous pouvez contacter l’équipe CoviDIAB Algérie qui saura vous renseigner, par email : contact@covidiab-algerie.com. Vous pouvez aussi contacter à ce sujet l’équipe IRIADE : contact@iriade.fr. Si vous avez des questions relatives à vos droits de participant à CoviDIAB Algérie, vous pouvez aussi contacter le responsable des données personnelles et de santé d’IRIADE : cdo@iriade.fr , ou le délégué à la protection des données personnelles et de santé : dpo@iriade.fr. Nous vous recommandons de consulter, avant de valider le consentement, les mentions légales du service en ligne CoviDIAB Algérie, et les Conditions Générales d’Utilisation - CGU (liens figurant sur toutes les pages du site covidiab-algerie.com, et dans l’application web CoviDIAB Algérie).
        </p>

        <p class="pt-1">
          En validant votre consentement à rejoindre et participer au programme CoviDIAB Algérie, vous indiquez également avoir pris connaissance préalablement des informations figurant sur ce document et les annexes citées et en accepter les principes d’application, avoir été suffisamment informé.e pour prendre votre décision, et vous vous engagez à respecter les conditions de participation qui sont décrites ci-dessus.
        </p>

      </div>
      <b class="text-xs-center mb-2">Pour consulter les conditions d'utilisation du service CoviDIAB Algérie en langue arabe, téléchargez le fichier ci-dessous :</b>

      <a @click="fileDownload"
         target="_blank"
         class="plain-link">
        <div style="display: flex; justify-content: center">
          <div class="MediaCard"
               style="position: relative;">
            <img ref="media_thumbnail"
                 :src="base64Img"
                 style="min-width: 100%; max-height: 130px; object-fit: contain"
                 alt="Vignette média">
            <h4 class="px-1">{{ appDatas.consentFile && appDatas.consentFile.title }}</h4>
          </div>
        </div>
      </a>

      <v-btn block
             class="mb-4"
             color="primary"
             :loading="ui.loading"
             @click="submit">
        OUI, je donne mon consentement
      </v-btn>

      <v-btn block
             @click="ui.step = 'no-consent-confirm'"
             :disabled="true">
        NON, je ne consens pas
      </v-btn>
    </div>

    <div v-show="ui.step === 'no-consent-confirm'">
      <h3 class="mt-2 primary--text text-xs-center fw500">Vous ne consentez pas au programme OBE-COACH.</h3>
      <v-textarea placeholder="Pourquoi ? (facultatif)"
                  v-model="reason"></v-textarea>
      <v-btn class="primary"
             block
             @click="submitConsentRejected">Confirmer
      </v-btn>
      <v-btn block
             @click="ui.step = 3">Annuler
      </v-btn>
    </div>

    <div v-show="ui.step === 'rejected-consent'">
      <h3 class="mt-2 primary--text text-xs-center fw500">Merci pour votre retour. Vous pouvez fermer cette page.</h3>
    </div>
  </div>
</template>

<script>
import api from 'api'
import FileSaver from 'file-saver'
import { mapGetters } from 'vuex'
import IriadeDatePickerFormBlock from '../Iriade/Blocks/IriadeFormBlock/Inputs/IriadeDatePickerFormBlock'
import IriadeFile from '../Iriade/IriadeFile'
import IriadeMaskedTextInput from '../Iriade/IriadeMaskedTextInput'

export default {
  components: {
    IriadeDatePickerFormBlock,
    IriadeMaskedTextInput,
    IriadeFile
  },
  computed: {
    formFilled () {
      return this.user.hypertension && this.user.diabetes && this.user.excess_cholesterol && this.user.height && this.user.max_weight
    },

    file_url: function () {
      return this.appDatas.consentFile.media_url + '/file'
    },

    thumbnail_url: function () {
      return this.appDatas.consentFile.media_url + '/thumbnail/'
    },

    ...mapGetters('application', ['application'])
  },

  data () {
    return {
      user: {
        username: '',
        email: '',
        password: null,
        password_confirm: null,
        phoneNumber: '',
        medecin_traitant: null,
        diabetologue: null,
        centre_hospitalier: null,
        city: null,
        gender: null,
        birthdate: null,
      },
      appDatas: {},
      reason: '',
      ui: {
        animate: false,
        loading: false,
        step: 0
      },
      base64Img: null,
    }
  },

  methods: {
    fileDownload: function () {
      api.get(this.file_url, { responseType: 'blob' })
        .then(result => {
          FileSaver.saveAs(result.data, this.appDatas.consentFile.title)
        })
    },

    thumbnailDownload: function () {
      api.get(this.thumbnail_url, {
        responseType: 'arraybuffer'
      }).then(result => {
        this.base64Img = 'data:' + result.headers['content-type'] + ';base64,' + new Buffer(result.data, 'binary').toString('base64')
      })
    },

    submit () {
      this.ui.loading = true
      api.post('auth/consent', {
        token: this.$route.params.token,
        ...this.user
      })
        .then(() => {
          document.location.reload()
        })
        .catch(err => {
          this.$router.push({ name: 'auth@login' })
        })
        .then(() => {
          this.ui.loading = false
        })
    },

    submitConsentRejected () {
      api.post(`auth/consent/reject/${this.$route.params.token}`, { reason: this.reason })
        .then(() => {
          this.ui.step = 'rejected-consent'
        })
    }
  },

  mounted () {
    this.ui.animate = true
    this.ui.loading = true
    api.get(`auth/signup/${this.$route.params.token}`)
      .then(res => {
        this.user.username = res.data.username
        this.user.email = res.data.email
        this.user.phoneNumber = res.data.phoneNumber
        this.appDatas = res.data.appDatas
        this.ui.loading = false
        this.thumbnailDownload()
      })
      .catch(() => {
        this.$router.push({ name: 'auth@login' })
      })
  }
}
</script>

<style lang="scss"
       type="text/scss">
.MediaCard {
  flex: 1 0 300px;
  box-sizing: border-box;
  margin: 1rem .5em;
  padding: 10px;
  cursor: pointer;
  user-select: none;
  border-radius: 12px;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.15);
  max-width: 100%;

  img {
    max-width: 100%;
    max-height: 100%;
  }
}
</style>
